module.exports = __webpack_public_path__ + "static/media/sidebar-sms.4a3ed722.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-sms.svg
// module id = 789
// module chunks = 0